"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgPersonCommunity = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_PERSON-COMMUNITY", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M13.5 14v-1.795c0-.317-.061-.798-.385-1.252-.439-.614-1.324-1.41-3.018-1.926C10.38 9.009 10.68 9 11 9c3.506 0 4.622 1.115 4.912 1.521a.536.536 0 0 1 .088.317V13a1 1 0 0 1-1 1h-1.5ZM10 12.777V14H2v-1.223C2.465 12.48 3.592 12 6 12s3.535.48 4 .777Zm-8.282.23.014-.017-.014.018Zm8.55-.017c.01.011.014.018.014.018l-.014-.018ZM.106 11.825a.643.643 0 0 0-.106.38V15a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-2.795a.643.643 0 0 0-.106-.38C11.546 11.338 10.207 10 6 10S.454 11.338.106 11.825ZM10 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM8 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM11 4a4.977 4.977 0 0 1-.9 2.863 3 3 0 1 0 0-5.725c.567.81.9 1.797.9 2.862Z" }))); };
exports.default = SvgPersonCommunity;
